import React, { useEffect, useState } from 'react';

function ClinicLinkInputForm({validUrl, onLinkSubmit}) {
  const [inputValue, setInputValue] = useState('');

  useEffect(() => {
    if (validUrl) {
      setInputValue(validUrl);
    }
   }, [validUrl]);
  const handleSubmit = (e) => {
    e.preventDefault();
    onLinkSubmit(inputValue);
  };

  return (
    <form className="p-4 border rounded shadow-sm bg-light mx-auto my-2 row" onSubmit={handleSubmit}>
      <div className="form-group my-1">
        <label className="form-label fw-bold">Clinic Link</label>
            <input
              type="text"
              className="form-control form-control-alternative col-10"
              placeholder="Enter clinic waiting area link"
              value={inputValue}
              onChange={(e) => setInputValue(e.target.value.split('?')[0])}
              required
            />
      </div>
      <small id="clinicHelp" className="fs-9">
        Copy and paste the link from the waiting area dashboard under
        'Share the link to your waiting area'. This will look like one of
        these examples:
        <ul className="my-2">
          <li>https://vcc.healthdirect.org.au/t/acmehealth1/join or</li>
          <li>https://videocall.direct/acme or</li>
          <li>
            https://vcc.healthdirect.org.au/t/acmehealth1/team/waiting-area
          </li>
        </ul>
      </small>

      <button type="submit" className="btn btn-outline-primary">Continue</button>
    </form>
  );
}

export default ClinicLinkInputForm;
